import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { SoftwareSpecificSearchService } from '../software-specific-search.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { distinctUntilChanged } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SoftwareTermsUsePopupComponent } from './software-terms-use-popup/software-terms-use-popup.component';
import { RegisterService } from 'src/app/services/feature/register.service';


@Component({
  selector: 'app-soft-ware-request-form-page',
  templateUrl: './soft-ware-request-form-page.component.html',
  styleUrls: ['./soft-ware-request-form-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SoftWareRequestFormPageComponent {
  private service = inject(SoftwareSpecificSearchService);
  private activatedroute = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);
  private authService = inject(AuthService);
  private matdialog = inject(MatDialog);
  private router = inject(Router);
  private registerservice = inject(RegisterService);
  private glbMsgservice = inject(GlobalMessageService);

  apiData$: Observable<any>;
  getCountry$: Observable<any>;
  canLoadPage: boolean = false;
  apiResponse: any;
  softWareTypeCode: string;
  softWareCode: string;
  isUserLoggedIn: boolean = false;
  apiPayLoad;

  isRecaptchaDone: boolean = false;
  subscription = new Subscription();


  companyInfo = new FormGroup({
    company: new FormControl(null, { validators: Validators.required }),
    firstName: new FormControl(null, { validators: Validators.required }),
    lastName: new FormControl(null, { validators: Validators.required }),
    country: new FormControl(null, { validators: Validators.required }),
    postalcode: new FormControl(null, { validators: Validators.required }),
    email: new FormControl(null, [Validators.email, Validators.required]),

  });

  captchaSection = new FormGroup({
    privacyTermsCheckBox: new FormControl(false),
    recaptcha: new FormControl(null, { validators: Validators.required }),
  })

  ngOnInit() {
    this.subscription.add(this.activatedroute.queryParamMap.subscribe((params) => {
      this.softWareCode = params.get('code');
      this.apiData$ = this.service.getSoftwareFormPage(this.softWareCode);
      this.getCountry$ = this.registerservice.getRegisterPageFields();
      this.pageLoadstateChanges();
    }));
  }
  pageLoadstateChanges() {
    this.subscription.add(this.authService.isUserLoggedIn().pipe(distinctUntilChanged()).
      subscribe((res: boolean) => {
        this.isUserLoggedIn = res;
        this.apiData$.subscribe((res: any) => {
          this.apiResponse = res;
          if (this.isUserLoggedIn) {
            this.prePopulateFormData(res?.companyInfo);
          }
          this.canLoadPage = true;
          this.cdr.detectChanges();
        });
      }));
  }
  prePopulateFormData(res) {
    this.companyInfo.controls.company.setValue(res?.company);
    this.companyInfo.controls.email.setValue(res?.email);
    this.companyInfo.controls.postalcode.setValue(res?.postalcode);
    this.companyInfo.controls.country.setValue(res?.country);
    this.companyInfo.controls.firstName.setValue(res?.firstName);
    this.companyInfo.controls.lastName.setValue(res?.lastName);
  }
  canSubmit() {
    if (this.companyInfo.valid) {
      this.glbMsgservice.remove(GlobalMessageType.MSG_TYPE_ERROR);
      this.apiPayLoad = this.payLoadCreator();
      this.postApiCall();
    } else {
      this.glbMsgservice.add({ key: 'common.text_contactusform_submission_error' }, GlobalMessageType.MSG_TYPE_ERROR)
      this.companyInfo.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }
  payLoadCreator() {
    return {
      softwareCode: this.softWareCode,
      softwareType: this.apiResponse.softwarePackageInfo.softwareType,
      //companyInFo
      company: this.companyInfo.controls.company.value,
      firstName: this.companyInfo.controls.firstName.value,
      lastName: this.companyInfo.controls.lastName.value,
      country: this.companyInfo.controls.country.value,
      postalcode: this.companyInfo.controls.postalcode.value,
      emailID: this.companyInfo.controls.email.value,
      //captchaInfo
      captchaCode: this.captchaSection.controls.recaptcha.value ?? ''
    }
  }

  postApiCall() {
    this.subscription.add(this.service.postSoftWareForm(this.apiPayLoad).subscribe((x: any) => {
      if (x.status.toLowerCase() == 'success') {
        this.router.navigateByUrl('/softwareConfirmationPage');
      }
    }));
  }

  //OpeningPopups and maintaining them
  openPrivacyPopup() {
    const ref = this.matdialog.open(SoftwareTermsUsePopupComponent, { minHeight: 390 });
    this.subscription.add(ref.afterClosed().subscribe(() => {
      this.captchaSection.controls.privacyTermsCheckBox.setValue(this.service.PrivacyTerms);
      this.cdr.detectChanges();
    }));
  }
  //checking the captcha
  checkCaptcha(captchaResponse: any) {
    this.isRecaptchaDone = captchaResponse && captchaResponse.length > 0 ? true : false;
  }
  ngOnDestroy() {
    //reinitializing the service memory to initial state
    this.service.PrivacyTerms = false;
    this.subscription.unsubscribe();

  }

}
